import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOfferinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.414 7.014l-8.278 8.279a1 1 0 0 1-1.415 0L.707 10.279a1 1 0 0 1 0-1.415L8.986.586A2 2 0 0 1 10.4 0H15a1 1 0 0 1 1 1v4.6a2 2 0 0 1-.586 1.414zM12.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgOfferinline;
